module.exports = __webpack_public_path__ + "media/images/background/error-bg-d782b1f263ca50d4ab3670467c66624a.jpg";